module.exports = __webpack_public_path__ + "static/media/YF32_2.0bddedae.jpg";